module.exports = __webpack_public_path__ + "img/business_Image_three.2ee19cdc.png";